import { types } from "../types/types";

export const getEnhancedIcons = (data) => ({
  type: types.getEnhancedIcons,
  payload: data,
});

export const importEnhancedIcons = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getEnhancedIcons(data));
    } catch (error) {
      console.error(error);
    }
  };
};
